<template>
  <v-container>
    <h1 class="devcentre-intro">Let's Design Your Software Solution</h1>
    <p class="devcentre-text">
      Chat with our AI advisor to explore your business needs and potential
      features. We'll help you shape your ideas into a clear plan for building
      your application.
    </p>
    <br />

    <AIAssistant></AIAssistant>
  </v-container>
</template>

<script>
import AIAssistant from "@/components/AIAssistant";
export default {
  name: "AssistantView",
  components: {
    AIAssistant,
  },
};
</script>
